export default "__VITE_ASSET__CZDkx2DP__"